export const DATE_COLUMN_SIZE = 2;
export const STATUS_COLUMN_SIZE = 1;
export const SPEED_COLUMN_SIZE = 1;
export const ADDRESS_COLUMN_SIZE = 3;
export const DATE_COLUMN_MAX_WIDTH = 150;
export const STATUS_COLUMN_MAX_WIDTH = 60;
export const SPEED_COLUMN_MAX_WIDTH = 80;

export const TRACKING_COLUMNS = [
  {
    title: 'Fecha',
    size: DATE_COLUMN_SIZE,
    maxWidth: DATE_COLUMN_MAX_WIDTH,
  },
  {
    title: 'Estatus',
    size: STATUS_COLUMN_SIZE,
    maxWidth: STATUS_COLUMN_MAX_WIDTH,
    centered: true,
  },
  {
    title: 'Velocidad',
    size: SPEED_COLUMN_SIZE,
    maxWidth: SPEED_COLUMN_MAX_WIDTH,
    centered: true,
  },
  {
    title: 'Dirección',
    size: ADDRESS_COLUMN_SIZE,
  },
];
